/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const FlightTravelerRequiredField = {
    GivenName: 'given_name',
    FamilyName: 'family_name',
    BornOn: 'born_on',
    Gender: 'gender',
    Phone: 'phone',
    Email: 'email',
    IdentityDocumentToken: 'identity_document_token',
    LoyaltyAccount: 'loyalty_account'
} as const;
export type FlightTravelerRequiredField = typeof FlightTravelerRequiredField[keyof typeof FlightTravelerRequiredField];


export function instanceOfFlightTravelerRequiredField(value: any): boolean {
    for (const key in FlightTravelerRequiredField) {
        if (Object.prototype.hasOwnProperty.call(FlightTravelerRequiredField, key)) {
            if (FlightTravelerRequiredField[key as keyof typeof FlightTravelerRequiredField] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlightTravelerRequiredFieldFromJSON(json: any): FlightTravelerRequiredField {
    return FlightTravelerRequiredFieldFromJSONTyped(json, false);
}

export function FlightTravelerRequiredFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightTravelerRequiredField {
    return json as FlightTravelerRequiredField;
}

export function FlightTravelerRequiredFieldToJSON(value?: FlightTravelerRequiredField | null): any {
    return value as any;
}

export function FlightTravelerRequiredFieldToJSONTyped(value: any, ignoreDiscriminator: boolean): FlightTravelerRequiredField {
    return value as FlightTravelerRequiredField;
}
